import { render } from "./DirPickJunta.vue?vue&type=template&id=fe7d1f68"
import script from "./DirPickJunta.vue?vue&type=script&lang=ts"
export * from "./DirPickJunta.vue?vue&type=script&lang=ts"
script.render = render

export default script